import { ChatResponseStatus } from "@/components/ai-chat/types";

import type { ChatHistoryEntry } from "@/types/chat-thread";

import { useAskDecodaStore } from "@/stores/ask-decoda-store";

export function cancelledResponseKey(
  tenant: string | undefined,
  responseId: string,
) {
  return JSON.stringify([tenant, responseId]);
}

/** Browser-only Stop intent. This never changes server execution ownership.
 * Keep a late HTTP response/history read from reattaching a response stopped by
 * the local five-second deadline before server acceptance was observable.
 */
export function projectCancelledAskDecodaEntry(
  tenant: string | undefined,
  entry: ChatHistoryEntry,
): ChatHistoryEntry {
  if (
    !useAskDecodaStore.getState().cancelledResponses[
      cancelledResponseKey(tenant, entry.id)
    ]
  ) {
    return entry;
  }
  return {
    ...entry,
    status: ChatResponseStatus.CANCELLED,
    progressMessage: undefined,
  };
}
